import React from 'react';
const availabilityIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='20'
    viewBox='0 0 18 20'
    {...props}
  >
    <path
      id='today'
      d='M6,2V4H5A2.015,2.015,0,0,0,3,6V20a2.015,2.015,0,0,0,2,2H19a2.015,2.015,0,0,0,2-2V6a2.015,2.015,0,0,0-2-2H18V2H16V4H8V2ZM5,9H19V20H5Zm9.8,2.3-3.3,3.3L9.7,12.8,8.3,14.2l3.2,3.2,4.7-4.7Z'
      transform='translate(-3 -2)'
      style={{
        fill: 'currentColor',
      }}
    />
  </svg>
);
export default availabilityIcon;
